export const University_form = {
  University_Name: "",
  Country_Id: "", //int dropdown
  // Created_By: "",
  // Created_On: todayDate,
  // Modified_By: "",
  // Modified_On: todayDate,
  // Active: "1",
  World_Ranking: "", //int
  Country_Ranking: "", //int
  University_Address: "",
  Affiliation: "", // dropdown int 0 or 1
  Affiliation_Pathway: "",
  Contact_Person: "",
  Contact_Number: "", // type mobile number
  Contact_Email: "",
  Commision_Percentage_PG: "", // float
  Commision_Including_GST: "", //drop down 1 0  yes/no
  Commission_Duration: "",
  Lumpsum_Commision: "",
  Attachment_Name: "",
  Commision_Percentage_UG: "", // float
  Commision_Percentage_Other: "", // float
  Partnership: "", //drop down 1 0  yes/no
};
// University form End //

export const University_Form_Checker = (data) => {
  if (
    (data.University_Name === "" || data.University_Name === null) &&
    (data.Country_Id === "" || data.Country_Id === null)
  ) {
    return ["University Name Mandatory!", "Country Name Mandatory!"];
  } else if (data.University_Name === "" || data.University_Name === null) {
    return ["University Name Mandatory!"];
  } else if (data.Country_Id === "" || data.Country_Id === null) {
    return ["Country Name Mandatory!"];
  } else {
    return ["success"];
  }
};

//  University Table

export const University_Table_Model = [
  "Edit/Delete",
  "University Name",
  "University Address",
  "Country Name",
  "Contact Person",
  "Contact Email",
  "World Ranking",
  "Country Ranking",
  "Attachment Name",
];
